import IFeedData from './IFeedData';

export default {
    /**
     * Checks the given feedData's source data for any value other than empty string and null
     * @returns true on values found, false otherwise
     */
    hasValues(feedData: IFeedData): boolean {
        if (feedData.sourceData) {
            const keys = Object.keys(feedData.sourceData);
            for (const key of keys) {
                if (feedData.sourceData[key] !== '' && feedData.sourceData[key] != null) {
                    return true;
                }
            }
        }
        return false;
    },
};
